module.exports = {template: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 46"><path d="M24 .038l8 14.3 16 3.2-11.1 12.1 1.9 16.3-14.8-6.8-14.8 6.9 1.9-16.3L0 17.538l16-3.2 8-14.3z"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/star.svg
// module id = 117
// module chunks = 1